import {Color, Vector2} from 'three'
import type {Gltf, Image, TextureData} from './assets-type'
import {path} from './assets-type'

export const duckAssets = {
  gltfs: {
    duck: {
      src: `${path}/mascot/duck/duck.glb`,
      scene: null,
    },
  } as {[key: string]: Gltf},
  images: {
    // matcap
    matcap_mascot: {
      src: `${path}/matcaps/mascot.jpg`,
      texture: null,
      flipY: false,
    },
    star: {
      src: `${path}/textures/star.jpg`,
      texture: null,
      flipY: false,
    },
    // duck
    duck_body_ao: {
      src: `${path}/mascot/duck/textures/body_sss.jpg`,
      texture: null,
      flipY: false,
    },
    duck_beak_ao: {
      src: `${path}/mascot/duck/textures/beak_sss.jpg`,
      texture: null,
      flipY: false,
    },
    duck_eyes_ao: {
      src: `${path}/mascot/duck/textures/eyes_sss.jpg`,
      texture: null,
      flipY: false,
    },
    duck_eyeballs_ao: {
      src: `${path}/mascot/duck/textures/eyeballs_sss.jpg`,
      texture: null,
      flipY: false,
    },
  } as {[key: string]: Image},
}

export const duckTextureData: {[key: string]: TextureData} = {
  body: {
    ao: 'duck_body_ao',
    color: null,
    colorVec: new Color(0xf5ae33),
    matcap: 'matcap_mascot',
    noiseRange: new Vector2(-0.03, 0.03),
    fogRangeZ: new Vector2(-1.0, -0.3),
  },
  beak: {
    ao: 'duck_beak_ao',
    color: null,
    colorVec: new Color(0xf5ae33),
    matcap: 'matcap_mascot',
    noiseRange: new Vector2(-0.03, 0.03),
    fogRangeZ: new Vector2(-1.0, -0.3),
  },
  eyes: {
    ao: 'duck_eyes_ao',
    color: null,
    colorVec: new Color(0x000000),
    matcap: 'matcap_mascot',
    noiseRange: new Vector2(-0.03, 0.03),
    fogRangeZ: new Vector2(-1.0, -0.3),
  },
  eyeballs: {
    ao: 'duck_eyeballs_ao',
    color: null,
    colorVec: new Color(0x000000),
    matcap: 'matcap_mascot',
    noiseRange: new Vector2(-0.03, 0.03),
    fogRangeZ: new Vector2(-1.0, -0.3),
  },
}
